import React from 'react';
import Select from 'react-select';

export default props => {
  const { options, value, onChange } = props;
  return <Select {...props} options={options} />;
};
